
import { TextBox } from 'devextreme-react/text-box';
import React, { useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Loader, Modal } from 'semantic-ui-react';
import { formRegisterApi } from '../../api/formRegisterApi';
import { useCommonContext } from '../../contexts/common';
import { showNotify } from '../../helpers/toast';
import DateBox from 'devextreme-react/date-box';
import { useSelector } from 'react-redux';
import { FormCobobox } from '../form/Editor';
import { appConst } from '../../app-const';
import FormTagBox from '../form/Editor/FormTagbox';
import moment from 'moment'
import { SelectBox } from 'devextreme-react';
import { hocSinhApi } from '../../api/hocsinh_api';
import { quanHeGiaDinhApi } from '../../api/quanHeGiaDinhApi';
import { khoiApi } from '../../api/dm_khoi_api';
import { cauHinhMaHocSinhApi } from '../../api/cauhinh_mahocsinh_api';

export default ({ ts_form_items, item, onSuccess, onCancel, formEditor, dm_chiendichs, ts_form_register_result_details }) => {
  const { dm_coso_id } = useSelector(x => x.coSo)
  const { nam_hoc } = useSelector(x => x.namHoc)
  const { translate } = useCommonContext();
  const [ chiendichs, set_chiendichs] = useState([]);
  const [formItem, setFormItem] = useState({});
  const [isSaving, setIsSaving] = useState(false);
  const { register, trigger, errors } = useForm();
  const componentDidMount = useRef(false);

  useEffect(() => {
    const _listData = dm_chiendichs.filter(
      (y) => y.dm_coso_id == dm_coso_id
    );
    const _listData2 = _listData.filter(
      (y) => y.nam_hoc == nam_hoc
    );
    // console.log(_listData2);
    set_chiendichs(_listData2);
  }, [dm_chiendichs]);

  const handleSaveChanges = async (datas) => {
    trigger().then(async () => {
      try {
        if (formItem.id > 0) {
          if (formItem.ts_hocsinh_id == 0) {
            await formRegisterApi.UpdateResult(
              {
                is_update_invite: formItem.is_update_invite,
                ts_hocsinh_id: 0,
                dm_chiendich_id: formItem.dm_chiendich_id,
                id: formItem.id
              }
            );
            await ts_form_items.forEach(async (x) => {
              var value = formItem[`T_${x.id}`];
              var id = formItem[`Id_${x.id}`];
              if (id != undefined) {
                await formRegisterApi.UpdateDetail({ value: value, id: id });
              }else{
                await formRegisterApi.InsertDetail({
                  phone_number : item.data.phone_number,
                  ts_form_editor_id : x.ts_form_editor_id,
                  ts_form_id : x.ts_form_id,
                  ts_form_item_id : x.id,
                  ts_form_register_result_id : item.data.id,
                  value : value
              });
              }
            });
  
            showNotify({
              text: translate('Update thành công'),
              type: 'success',
            });
            onSuccess();
          } else {
            var isAdd = await addHocSinh();
            if(isAdd){
              await ts_form_items.forEach(async (x) => {
                var value = formItem[`T_${x.id}`];
                var id = formItem[`Id_${x.id}`];
                if (id != undefined) {
                  await formRegisterApi.UpdateDetail({ value: value, id: id });
                }
              });
    
              showNotify({
                text: translate('Update thành công'),
                type: 'success',
              });
              onSuccess();
            }
           
          }

          
        }
      } catch (error) {
        showNotify({
          text: translate('Cập nhật thất bại'),
          type: 'error',
        });
      }

    });
  };
  const insertHS = async (value) => {
    if (value.ho_ten == null) {
      return {
        text: translate(`Họ tên học sinh bị trống`),
        type: 'error',
      };
    }
    if (value.dm_khoi_id == null || isNaN(value.dm_khoi_id)) {
      return {
        text: translate(`Khối học sinh ${value.ho_ten} bị trống`),
        type: 'error',
      };
    }
    if (value.dm_he_id == null) {
      return {
        text: translate(`Hệ học sinh ${value.ho_ten} bị trống`),
        type: 'error',
      };
    }
    if (value.ngay_sinh_timestamp == null) {
      return {
        text: translate(`Ngày sinh học sinh ${value.ho_ten} bị trống`),
        type: 'error',
      };
    }
    const resKhoi = await khoiApi.Detail(value.dm_khoi_id);
    var dm_truong_id = value.dm_truong_id != null ? value.dm_truong_id : 0;
    if (resKhoi.is_success) {
      dm_truong_id = resKhoi.data.dm_truong_id;
    }

    var namHoc = value.nam_hoc != null ? value.nam_hoc : nam_hoc;
    const resCauHinh = await cauHinhMaHocSinhApi.SelectByCoSo(dm_coso_id);
    if (resCauHinh.is_success) {
      if (resCauHinh.data.length > 0) {
        const filterByNamHoc = resCauHinh.data.filter((x) => x.nam_hoc == namHoc && x.is_active == true);
        if (filterByNamHoc != null && filterByNamHoc.length > 0) {
          var gioiHanTren = Math.pow(10, filterByNamHoc[0].so_kytu_tutang) - 1;
          if (filterByNamHoc[0].so_hientai >= 0 && filterByNamHoc[0].so_hientai <= gioiHanTren) {
            var formDataSubmit = {
              id: 0,
              nam_hoc: namHoc,
              nam_nhap_hoc: namHoc,
              ho_ten: value.ho_ten,
              ngay_sinh_timestamp: value.ngay_sinh_timestamp,
              ngay_nhap_hoc_timestamp: new Date().getTime(),
              dm_gioitinh_id: value.dm_gioitinh_id != null ? value.dm_gioitinh_id : 1,
              dm_he_id: value.dm_he_id,
              dm_coso_id: dm_coso_id,
              dm_dantoc_id: 1,
              dm_tongiao_id: 1,
              dm_khoi_id: value.dm_khoi_id,
              dm_truong_id: dm_truong_id,
              truong_hoc_cu: value.truong_hoc_cu,
              dm_nguonbiettoi_id: value.dm_nguonbiettoi_id != null ? value.dm_nguonbiettoi_id : 0,
              dm_quoctich_id: value.dm_quoctich_id ? value.dm_quoctich_id : 1,
              dia_chi_tt: value.dia_chi_tt,
              dia_chi_noi_sinh: value.dia_chi_noi_sinh,
              que_quan: value.que_quan
            };
            var res = await hocSinhApi.Insert(formDataSubmit);
            // console.log(res);
            if (res.is_success) {
              if (value.dien_thoai_cha != null && value.dien_thoai_cha != "") {
                if (value.dien_thoai_cha.toString().startsWith('0') && value.dien_thoai_cha.toString().length == 10) {
                  const formDataSubmit = {
                    dien_thoai: value.dien_thoai_cha,
                    ts_hocsinh_id: res.data,
                    dm_coso_id: dm_coso_id,
                    dm_quanhe_id: 1
                  };
                  await quanHeGiaDinhApi.Insert(formDataSubmit);
                }
              }
              if (value.dien_thoai_me != null && value.dien_thoai_me != "") {
                if (value.dien_thoai_me.toString().startsWith('0') && value.dien_thoai_me.toString().length == 10) {
                  const formDataSubmit = {
                    dien_thoai: value.dien_thoai_me,
                    ts_hocsinh_id: res.data,
                    dm_coso_id: dm_coso_id,
                    dm_quanhe_id: 2
                  };
                  await quanHeGiaDinhApi.Insert(formDataSubmit);
                }
              }
              if (value.dien_thoai_giam_ho != null && value.dien_thoai_giam_ho != "") {
                if (value.dien_thoai_giam_ho.toString().startsWith('0') && value.dien_thoai_giam_ho.toString().length == 10) {
                  const formDataSubmit = {
                    dien_thoai: value.dien_thoai_giam_ho,
                    ts_hocsinh_id: res.data,
                    dm_coso_id: dm_coso_id,
                    dm_quanhe_id: 3
                  };
                  await quanHeGiaDinhApi.Insert(formDataSubmit);
                }
              }
              formItem.ts_hocsinh_id = res.data;
              await formRegisterApi.UpdateResult(
                {
                  is_update_invite: formItem.is_update_invite,
                  ts_hocsinh_id: formItem.ts_hocsinh_id ,
                  dm_chiendich_id: formItem.dm_chiendich_id,
                  id: formItem.id
                }
              );
              // await formRegisterApi.UpdateResult({ ts_hocsinh_id: res.data, id: value.ts_form_register_result_id });
              return { text: translate('Cập nhật thành công '), type: 'success' };
            } else {
              return { text: res.message, type: 'error' };
            }
            return res;
          } else {
            return {
              text: translate(`Vui lòng xem lại cấu hình mã học sinh năm học ${namHoc} `),
              type: 'error',
            };
          }
        } else {
          return {
            text: translate(`Vui lòng xem lại cấu hình mã học sinh năm học1 ${namHoc} `),
            type: 'error',
          };
        }
      } else {
        return {
          text: translate(`Vui lòng xem lại cấu hình mã học sinh năm học1 ${namHoc} `),
          type: 'error',
        };
      }
    } else {
      return {
        text: translate(`Vui lòng xem lại cấu hình mã học sinh năm học ${namHoc} `),
        type: 'error',
      };
    }
    return null;
  }

  const addHocSinh = async () => {
    var datas = [];
      const _listData = ts_form_register_result_details.filter(
        (y) => y.ts_form_register_result_id == formItem.id
      );

      try {
        let _data = {
          nam_hoc: null,
          ho_ten: null,
          ngay_sinh_timestamp: null,
          dm_gioitinh_id: null,
          dm_he_id: null,
          dm_khoi_id: null,
          dm_truong_id: null,
          truong_hoc_cu: null,
          dm_nguonbiettoi_id: null,
          dm_quoctich_id: null,
          nam_hoc: null,
          dia_chi_tt: null,
          dia_chi_noi_sinh: null,
          que_quan: null,
          ts_form_register_result_id: null,
          dien_thoai_cha: null,
          dien_thoai_me: null,
          dien_thoai_giam_ho: null
        };
        _listData.forEach(element => {
          _data.ts_form_register_result_id = element.ts_form_register_result_id;
          switch (element.ts_form_editor_id) {
            case 2000:
              _data.ho_ten = element.value;
              break;
            case 2001:
              _data.dm_gioitinh_id = parseInt(element.value);
              break;
            case 2002:
              _data.ngay_sinh_timestamp = element.value ? moment(element.value, 'DD/MM/YYYY').toDate().getTime() : 0;
              break;
            case 2003:
              _data.dm_quoctich_id = parseInt(element.value);
              break;
            case 2004:
              _data.dm_truong_id = parseInt(element.value);
              break;
            case 2005:
              _data.dm_khoi_id = parseInt(element.value);
              break;
            case 2006:
              _data.dm_he_id = parseInt(element.value);
              break;
            case 2007:
              _data.truong_hoc_cu = element.value;
              break;
            case 2008:
              _data.dm_nguonbiettoi_id = parseInt(element.value);
              break;
            case 2009:
              _data.nam_hoc = element.value;
              break;
            case 2010:
              _data.dia_chi_tt = element.value;
              break;
            case 2011:
              _data.dia_chi_noi_sinh = element.value;
              break;
            case 2012:
              _data.que_quan = element.value;
              break;
            case 2015:
              _data.dien_thoai_cha = element.value;
              break;
            case 2015:
              _data.dien_thoai_me = element.value;
              break;
            case 2030:
              _data.dien_thoai_giam_ho = element.value;
              break;
            default:
              break;
          }
        });
        datas.push(_data);
      } catch (error) {
        console.log(error);
      }
    
    try {
      const res = await Promise.all(datas.map((value) => {
        return insertHS(value);
      }));
      if (res) {
        var success = true;
        res.forEach(x => {
          if (x.type == 'error') {
            formItem.ts_hocsinh_id = 0;
            showNotify({ text: x.text, type: x.type });
            success = false;
          }
        });
        if (success) {
          return true;
        }else{
          return false;
        }
      }
    } catch (error) {
      console.log(error);
    }
    return false;
  }

  useEffect(() => {
    componentDidMount.current = true;
    setFormItem(item.data);
    return () => {
      componentDidMount.current = false;
    }
  }, [item]);

  const renderItem = (x) => {
    const _find_editor_id = formEditor.find((val) => val.id === x.ts_form_editor_id);
    const type_name = _find_editor_id?.ts_form_editor_type_id;
    var parentId = 0;
    if(x.ts_form_editor_id == 2006){
      const khoiData = ts_form_register_result_details.find(y => y.ts_form_editor_id == 2005 && y.ts_form_register_result_id == formItem.id);
      console.log(khoiData);
      if(khoiData && khoiData.value!=null && khoiData.value != ""){
        parentId = parseInt(khoiData.value);
      }
    }
    if(x.ts_form_editor_id == 2005){
      const khoiData = ts_form_register_result_details.find(y => y.ts_form_editor_id == 2004 && y.ts_form_register_result_id == formItem.id);
      console.log(khoiData);
      if(khoiData && khoiData.value!=null && khoiData.value != ""){
        parentId = parseInt(khoiData.value);
      }
    }
    switch (type_name) {
      case appConst.formEditorType.text_box:

        return <TextBox
          stylingMode="outlined"
          onValueChanged={(e) => {
            item.data[`T_${x.id}`] = e.value;
            setFormItem(Object.assign({}, item.data));
          }}
          value={formItem[`T_${x.id}`]}
        />;
      case appConst.formEditorType.combobox:
        return <FormCobobox dm_coso_id={dm_coso_id} parent_id={parentId} value={item.data[`T_${x.id}`]} ts_form_editor_id={x.ts_form_editor_id} onValueChanged={(value) => {
          item.data[`T_${x.id}`] = value;
          setFormItem(Object.assign({}, item.data));
        }} />

      case appConst.formEditorType.date_box:
        return <DateBox
          displayFormat={'dd/MM/yyyy'}
          value={moment(formItem[`T_${x.id}`], 'DD/MM/YYYY').toDate()}
          onValueChanged={(e) => {
            item.data[`T_${x.id}`] = moment(e.value).format('DD/MM/YYYY');
            setFormItem(Object.assign({}, item.data));
          }}
        />;
      case appConst.formEditorType.tagbox:
        return <FormTagBox dm_coso_id={dm_coso_id} ts_form_editor_id={x.ts_form_editor_id} value={formItem[`T_${x.id}`]} onValueChanged={(value) => {
          item.data[`T_${x.id}`] = value;
          setFormItem(Object.assign({}, item.data));
        }} />
      default:
        return <TextBox
          stylingMode="outlined"
          onValueChanged={(e) => {
            item.data[`T_${x.id}`] = e.value;
            setFormItem(Object.assign({}, item.data));
          }}
          value={formItem[`T_${x.id}`]}
        />;
    }
  }
  return (
    <div>
      <Modal
        open={true}
        size="large"
        dimmer={'blurring'}
        onClose={onCancel}
        closeOnEscape={false}
        closeOnDimmerClick={false}
      >
        <Modal.Header>
          <p>{translate('Cập nhật')}</p>
        </Modal.Header>
        <Modal.Content>
          <form className="ui">

            {/* <input className="hide" name="id" defaultValue={formItem.id}></input> */}
            <div className="row" >
              <div className="col-md-6 padding-top-1rem">
                <div className="dx-field-label">Chiến dịch</div>
                <br></br>
                <SelectBox
                  dataSource={chiendichs}
                  displayExpr={'ten_chien_dich'}
                  valueExpr={'id'}
                  value={formItem.dm_chiendich_id}
                  stylingMode="outlined"
                  // width={width}
                  searchEnabled
                  placeholder={translate('Chọn chiến dịch')}
                  showClearButton={true}
                  onValueChanged={(e) => {
                    if (e.event) {

                      item.data.dm_chiendich_id = e.value
                      setFormItem(Object.assign({}, item.data));
                    };
                  }}
                />
              </div>
              <div className="col-md-6 padding-top-1rem">
                <div className="dx-field-label">Cập nhật học sinh</div>
                <br></br>
                <SelectBox
                  dataSource={[{
                    value: '0',
                    label: "Chưa cập nhật"
                  },
                  {
                    value: '1',
                    label: "Đã cập nhật"
                  }]}
                  displayExpr={'label'}
                  valueExpr={'value'}
                  value={formItem.ts_hocsinh_id == 0 ? '0' : '1'}
                  stylingMode="outlined"
                  // width={width}
                  searchEnabled
                  // placeholder={translate('Chọn chiến dịch')}
                  // showClearButton={true}
                  onValueChanged={(e) => {
                    if (e.event) {
                      item.data.ts_hocsinh_id = e.value == '0' ? 0 : 1
                      setFormItem(Object.assign({}, item.data));
                    };
                  }}
                />
              </div>
              <div className="col-md-6 padding-top-1rem">
                <div className="dx-field-label">Tham gia hội thảo</div>
                <br></br>
                <SelectBox
                  dataSource={[{
                    value: '0',
                    label: "Chưa tham gia"
                  },
                  {
                    value: '1',
                    label: "Đã tham gia"
                  }]}

                  displayExpr={'label'}
                  valueExpr={'value'}
                  value={formItem.is_update_invite ? '1' : '0'}
                  stylingMode="outlined"
                  // width={width}
                  searchEnabled
                  placeholder={translate('Chọn chiến dịch')}
                  // showClearButton={true}
                  onValueChanged={(e) => {
                    if (e.event) {

                      // const data = dm_chiendichs.find(x => x.id == e.value)
                      item.data.is_update_invite = e.value == '1' ? true : false
                      setFormItem(Object.assign({}, item.data));
                    };
                  }}
                />
              </div>
              {ts_form_items.map((x) => {
                return (
                  <div className="col-md-6 padding-top-1rem">
                    <div className="dx-field-label">{x.label}</div>
                    <br></br>
                    {renderItem(x)}

                  </div>
                );
              })}
            </div>
          </form>
        </Modal.Content>
        <Modal.Actions>
          <div>
            <button onClick={onCancel} className="p-btn p-btn-sm">
              {translate('Đóng')}
            </button>
            <button
              disabled={isSaving}
              onClick={handleSaveChanges}
              className="p-btn p-prim-col p-btn-sm margin-left-10"
            >
              {translate('Cập nhật')}
              {isSaving && <Loader active inline size="mini" />}
            </button>
          </div>
        </Modal.Actions>
      </Modal>
    </div>
  );
};
